var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getSignedVAA } from "..";
import { coalesceChainId } from "../utils";
export function getSignedVAAWithRetry(hosts, emitterChain, emitterAddress, targetChain, sequence, extraGrpcOpts = {}, retryTimeout = 1000, retryAttempts) {
    return __awaiter(this, void 0, void 0, function* () {
        let currentWormholeRpcHost = -1;
        const getNextRpcHost = () => ++currentWormholeRpcHost % hosts.length;
        let result;
        let attempts = 0;
        while (!result) {
            attempts++;
            yield new Promise((resolve) => setTimeout(resolve, retryTimeout));
            try {
                result = yield getSignedVAA(hosts[getNextRpcHost()], coalesceChainId(emitterChain), emitterAddress, targetChain, sequence, extraGrpcOpts);
            }
            catch (e) {
                if (retryAttempts !== undefined && attempts > retryAttempts) {
                    throw e;
                }
            }
        }
        return result;
    });
}
export default getSignedVAAWithRetry;
